var _ellipse, _ellipse2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    transform: "rotate(-180 7.5 7.5)",
    fill: "#ADADAD"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    transform: "rotate(-180 7.5 7.5)",
    fill: "#F3894E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3161_3602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.74998 7.1176C3.7751 7.12285 3.80023 7.1251 3.82498 7.1251C3.99973 7.1251 4.1561 7.00248 4.1921 6.82473C4.50973 5.26023 5.9006 4.1251 7.4996 4.1251C8.18248 4.1251 8.83535 4.3291 9.38923 4.70523L8.21923 5.87523L11.7056 6.4561L11.1247 2.96973L9.92548 4.16898C9.22423 3.65635 8.3831 3.3751 7.4996 3.3751C5.54548 3.3751 3.84523 4.76298 3.4571 6.67548C3.41585 6.87835 3.5471 7.07635 3.74998 7.1176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2493 7.88269C11.0464 7.84106 10.8484 7.97269 10.8072 8.17556C10.4896 9.74006 9.0987 10.8752 7.4997 10.8752C6.81683 10.8752 6.16395 10.6712 5.61008 10.2951L6.78008 9.12506L3.2937 8.54419L3.87458 12.0306L5.07383 10.8313C5.77508 11.3439 6.6162 11.6252 7.4997 11.6252C9.45382 11.6252 11.1541 10.2373 11.5422 8.32481C11.5834 8.12194 11.4522 7.92394 11.2493 7.88269Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3161_3602"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon19);
export default __webpack_public_path__ + "static/media/icon-19.e0504ce53bf11f747e8c0a20eecd892e.svg";
export { ForwardRef as ReactComponent };